import React from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import { ViewButton, EditButton } from '../Common/DataTable/tableActionButtons';
import { getFilter, getLabel, getSort } from '../Common/DataTable/tableHelpers';
import moment from 'moment';

const createTableColumns = (
  openViewModal,
  openEditModal,
  openArchiveModal,
  countries,
  openDuplicate,
) => [
  {
    title: 'Name',
    name: 'name',
    sort: true,
  },
  {
    title: 'Country',
    name: 'countryId',
    sort: true,
    formatterComponent: ({ value }) => getLabel(value, countries),
    sorting: (a, b) =>
      getSort(getLabel(a, countries), getLabel(b, countries)),
    filter: (value, filter) =>
      getFilter(getLabel(value, countries), filter.value),
  },
  {
    title: 'Description',
    name: 'description',
    sort: true,
  },
  {
    title: 'Archived',
    name: 'archived',
    width: 120,
    formatterComponent: ({ value }) =>
      value ? (
        <span className="badge badge-warning font-size-12">YES</span>
      ) : (
        <span className="badge badge-success font-size-12">NO</span>
      ),
    filter: (value, filter) => getFilter(value ? 'yes' : 'no', filter.value),
    sorting: (a, b) => getSort(a ? 'yes' : 'no', b ? 'yes' : 'no'),
  },
  {
    title: 'Created At',
    name: 'createdAt',
    width: 120,
    formatterComponent: ({ value }) => `${moment(value).fromNow()}`,
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(`${moment(value).fromNow()}`, filter.value),
  },
  {
    title: 'Action',
    name: 'action',
    width: 180,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        <ViewButton row={row} onPress={openViewModal} />
        <EditButton row={row} onPress={openEditModal} />
        <li className="list-inline-item px-1">
          <Link
            to="#"
            id={'duplicate_' + row.id}
            onClick={(event) => {
              event.preventDefault();
              openDuplicate(row);
            }}>
            <i className="bx bx-copy"></i>
            <UncontrolledTooltip
              placement="top"
              target={'duplicate_' + row.id}>
              Duplicate
            </UncontrolledTooltip>
          </Link>
        </li>
        <li className="list-inline-item px-1">
          <Link
            to="#"
            id={'archive_' + row.id}
            onClick={(event) => {
              event.preventDefault();
              openArchiveModal(row);
            }}>
            <i className="bx bx-archive-in"></i>
            <UncontrolledTooltip
              placement="top"
              target={'archive_' + row.id}>
              Archive
            </UncontrolledTooltip>
          </Link>
        </li>
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
